import { Component, OnInit, OnDestroy } from '@angular/core'
import { StoreService } from 'app/service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { CpmService } from 'app/service/cpm.service'
import { ActivatedRoute } from '@angular/router'
@Component({
  selector: 'app-foreign-limit',
  templateUrl: './foreign-limit.component.html',
  styleUrls: ['./foreign-limit.component.scss']
})
export class ForeignLimitComponent implements OnInit, OnDestroy {
  subscription: Subscription
  foreignLimitItem = {}
  foreignLimitTableOptions: DataTables.Settings = {}
  foreignLimitHeader = [
    '% Foreign limit',
    '% Foreign available',
    '% Foreign shareholder',
    '% NVDR holder'
  ]
  constructor(
    private cpmService: CpmService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params

    this.foreignLimitTableOptions = {
      autoWidth: false,
      paging: false,
      searching: false,
      info: false,
      ordering: false
    }

    if (symbol !== undefined) {
      this.getForeingLimit(symbol)
    } else {
      this.subscription = this.store
        .getSecurityProfileNewResultObservable()
        .subscribe(response => {
          if (!response) {
            return
          }
          this.getForeingLimit(response['securitySymbol'])
        })
    }
  }

  getForeingLimit(symbol) {
    this.cpmService.getForeignLimit(symbol).then(response => {
      this.foreignLimitItem['asOfDate'] = response.asOfDate
      this.foreignLimitItem['foreignLimit'] = response.foreignLimit
      this.foreignLimitItem['foreignAvailable'] = response.foreignAvailable
      this.foreignLimitItem['foreignHolder'] = response.foreignHolder
      this.foreignLimitItem['nvdrHolder'] = response.nvdrHolder
    })
  }

  ngOnDestroy() {
    this.subscription.unsubscribe()
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/foreign-limit/foreign-limit.component.ts